<template>
  <div class="base_box">
    <baseSearch @search="searchFun" @reset="resetFun" :list="searchFrom">
    </baseSearch>

    <div class="mt10 base_content" style="border-radius: 0">
      <table class="order_table" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <th align="left" style="padding-left: 20px">会员信息</th>
          <th align="center">身份</th>
          <th align="center">订单号</th>
          <th align="center">状态</th>
          <th align="center">创建时间</th>
          <th align="center">分红金额</th>
        </tr>
        <tbody v-if="search.table.length <= 0">
          <tr>
            <td colspan="6" style="padding: 0; border: 0">
              <div class="no_data">暂无数据</div>
            </td>
          </tr>
        </tbody>
        <tbody v-for="(item, index) in search.table" :key="index">
          <tr>
            <td align="left" style="padding-left: 20px">
              <div class="user_info">
                <img
                  class="user_img"
                  :src="(item.user && item.user.avatar && item.user.avatar.url) ? item.user.avatar.url : require('@/static/img/people.png')"
                  alt=""
                />
                <div class="user_right">
                  <div>{{ (item.user && item.user.nick_name) || '-' }}</div>
                  <div class="user_mobile">{{ (item.user && item.user.mobile) || '-' }}</div>
                </div>
              </div>
            </td>
            <td align="center">{{ item.poolprofit_type == 1 ? '店长' : item.poolprofit_type == 2 ? '合伙人' : '-' }}</td>
            <td align="center">
              <span
                v-if="item.order_no"
                class="order_no_link"
                @click="$router.push({ path: '/weishop/application/poolprofit/order', query: { order_no: item.order_no } })"
              >{{ item.order_no }}</span>
              <span v-else>-</span>
            </td>
            <td align="center">
              <span v-if="item.entry_status == 0" class="status_wait">待入账</span>
              <span v-else-if="item.entry_status == 1" class="status_done">已入账</span>
              <span v-else>-</span>
            </td>
            <td align="center">{{ item.created_at || '-' }}</td>
            <td align="center" class="price_text">{{ item.price >= 0 ? '+' + item.price : item.price }}</td>
          </tr>
        </tbody>
      </table>

      <div class="page_box">
        <el-pagination
          background
          @current-change="pageChange"
          @size-change="sizeChange"
          :current-page="search.post.page"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size="search.post.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="search.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import baseSearch from "@/components/common/baseSearch";

export default {
  components: { baseSearch },
  data() {
    return {
      searchFrom: [
        {
          type: "input",
          Field: "keyword",
          label: "会员昵称",
          placeholder: "请输入会员昵称、手机号",
          style: { width: "200px" },
        },
        {
          type: "input",
          Field: "order_no",
          label: "订单号",
          placeholder: "请输入订单号",
          style: { width: "180px" },
        },
        {
          type: "select",
          Field: "entry_status",
          label: "状态",
          placeholder: "请选择",
          style: { width: "120px" },
          options: [
            { label: "全部", value: "" },
            { label: "待入账", value: "0" },
            { label: "已入账", value: "1" },
          ],
        },
        {
          type: "select",
          Field: "poolprofit_type",
          label: "身份",
          placeholder: "请选择",
          style: { width: "120px" },
          options: [
            { label: "全部", value: "" },
            { label: "店长", value: "1" },
            { label: "合伙人", value: "2" },
          ],
        },
        {
          type: "datePicker",
          Field: "created_at",
          label: "创建时间",
          style: { width: "320px" },
        },
      ],
      search: {
        post: {
          page: 1,
          limit: 15,
          keyword: "",
          order_no: "",
          entry_status: "",
          poolprofit_type: "",
          start_time: "",
          end_time: "",
        },
        table: [],
        total: 0,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      let _this = this;
      let params = { ...this.search.post };
      if (!params.keyword) delete params.keyword;
      if (!params.order_no) delete params.order_no;
      if (params.entry_status === "") delete params.entry_status;
      if (params.poolprofit_type === "") delete params.poolprofit_type;
      if (!params.start_time) delete params.start_time;
      if (!params.end_time) delete params.end_time;

      params.change_type = 1;

      _this.axios({
        url: "/api/weishop/admin/plugin/poolprofit/balance/index",
        method: "get",
        params,
      }).then((res) => {
        if (res.code == 200) {
          _this.search.table = res.data.data || [];
          _this.search.total = res.data.total || 0;
        }
      });
    },
    // 搜索
    searchFun(e) {
      this.search.post.page = 1;
      this.search.post = { ...this.search.post, ...e };
      if (e.created_at && e.created_at.length == 2) {
        this.search.post.start_time = e.created_at[0];
        this.search.post.end_time = e.created_at[1];
      } else {
        this.search.post.start_time = "";
        this.search.post.end_time = "";
      }
      delete this.search.post.created_at;
      this.getList();
    },
    // 重置
    resetFun() {
      this.search.post = {
        page: 1,
        limit: 15,
        keyword: "",
        order_no: "",
        entry_status: "",
        poolprofit_type: "",
        start_time: "",
        end_time: "",
      };
      this.getList();
    },
    // 分页
    pageChange(e) {
      this.search.post.page = e;
      this.getList();
    },
    sizeChange(e) {
      this.search.post.limit = e;
      this.search.post.page = 1;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.user_info {
  display: flex;
  align-items: center;
}
.user_img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}
.user_right {
  line-height: 1.6;
}
.user_mobile {
  color: #999;
  font-size: 12px;
}
.status_wait {
  color: #e6a23c;
}
.status_done {
  color: #67c23a;
}
.price_text {
  color: #f56c6c;
}
.order_no_link {
  color: #006aff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.page_box {
  text-align: right;
  padding: 15px 20px;
}
</style>
